module.exports = __webpack_public_path__ + "static/photo28-0a38d056ed80db6cdfcffc6582892eb7.png";